import { DETECT_USER_AGENTS, LOCATE_IPS } from './mutationTypes';
import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';
import { UAParser } from 'ua-parser-js';

const _uaParser = new UAParser();
export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [DETECT_USER_AGENTS](state, logEntries) {
    state.logEntries = Object.values(logEntries);
    state.uniqueDetections = [];
    state.uniqueUserAgents = [];
    const processedUserAgents = {};

    for (let i = 0; i < state.logEntries.length; i++) {
      const logEntry = logEntries[i];
      if (!processedUserAgents[logEntry.userAgent]) {
        _uaParser.setUA(logEntry.userAgent);
        const result = _uaParser.getResult();
        let information = '';
        if (result) {
          information = result.browser.name;
          if (result.device.model != undefined) {
            information = information + ' ' + result.device.model;
          }
          if (result.os.name != undefined) {
            information = information + ' ' + result.os.name + ' ' + result.os.version;
          }
          if (result.cpu.architecture != undefined) {
            information = information + ' ' + result.cpu.architecture;
          }
        }
        if (information == '') {
          information = 'Not Available';
        }
        processedUserAgents[logEntry.userAgent] = information;
      }
    }
    state.uniqueUserAgents = Object.keys(processedUserAgents);
    state.uniqueDetections = Object.values(processedUserAgents);
    state.uniqueIps = state.logEntries.map(a => a.ip).filter((value, index, self) => self.indexOf(value) === index);
  },
  [LOCATE_IPS](state, uniqueGeoLocations) {
    const newLogEntries = [];
    const processedLocations = {};
    for (let i = 0; i < state.logEntries.length; i++) {
      const logEntry = state.logEntries[i];
      let location = processedLocations[logEntry.ip];
      if (!location) {
        location = '';
        const detectedLocation = uniqueGeoLocations[state.uniqueIps.findIndex(i => i == logEntry.ip)];
        if (detectedLocation != null) {
          if (detectedLocation.City != null) {
            location = location + detectedLocation.City + ' ';
          }
          if (detectedLocation.SubDivision != null) {
            location = location + detectedLocation.SubDivision + ' ';
          }
          if (detectedLocation.Country != null) {
            location = location + detectedLocation.Country;
          }
        } else {
          location = 'Not Available';
        }
        processedLocations[logEntry.ip] = location;
      }

      logEntry.userAgent = state.uniqueDetections[state.uniqueUserAgents.findIndex(i => i == logEntry.userAgent)];
      if (logEntry.userAgent == null || logEntry.userAgent == '') {
        logEntry.userAgent = 'Not Available';
      }

      if (logEntry.loginType == 'TokenRefresh') {
        logEntry.loginType = 'Token Refresh';
      }
      newLogEntries.push({ ...logEntry, location: location });
    }
    state.logEntries = newLogEntries;
  },
};